// import { type RadioItem } from "@kyan/ui";

import { useComboInstruments } from "#/store/combo/comboInstruments";

// import type { ComboType } from "#/store/combo/comboType";
// import { useComboType } from "#/store/combo/comboType";
import { ComboContent } from "./components/ComboContent/ComboContent";
import { EmptyState } from "./components/EmptyState/EmptyState";

// const items: RadioItem<ComboType>[] = [
//   { id: "orderbook", label: "Orderbook", className: "flex-1" },
//   { id: "rfq-options", label: "RFQ - Options Only", className: "flex-1" },
// ];

export const ComboTab: React.FC = () => {
  const { comboInstruments } = useComboInstruments();
  // const { comboType, setComboType } = useComboType();

  return (
    <div className="flex h-full max-h-[65vh] flex-col overflow-y-auto sm:max-h-none">
      {/* <RadioButton
        size="md"
        items={items}
        value={comboType}
        variant="secondary"
        className="mt-4.5 w-full gap-3 sm:px-4"
        onChange={setComboType}
      /> */}
      <div className="flex h-full flex-col gap-4 sm:p-4">
        {comboInstruments.length ? <ComboContent /> : <EmptyState />}
      </div>
    </div>
  );
};
